import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import FeatureBento from '../components/site/FeatureBento';
import { PageShell, QuoteButton } from '../components/site/PageParts';
import { ARTIST_BENTO_SECTIONS } from '../mock';
import useSeo from '../hooks/useSeo';

export default function ArtistMerch() {
  useSeo({
    title: 'Artist Merch | Merch Branding & Creative Direction | Pusha Teez',
    description:
      'Pusha Teez Artist Merch helps emerging artists and established brands build authentic merch, branding and full creative experiences — from product selection to production.',
    path: '/artist-merch',
  });
  return (
    <PageShell testid="artist-merch-page">
      <section className="relative px-6 py-20 md:py-32">
        <div className="max-w-[1400px] mx-auto text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-[#00b8ff] mb-6">Who we serve · Artists &amp; Bands</p>
          <h1 className="font-display text-[#f4efe6] uppercase text-[56px] sm:text-[80px] md:text-[120px] lg:text-[150px] leading-[0.9] tracking-tight">
            Artist <span className="font-script italic text-[#00b8ff] normal-case">Merch</span>
          </h1>
          <p className="text-[#cfc8bb] text-base md:text-lg max-w-2xl mx-auto mt-10 leading-relaxed">
            We&apos;re building something special. From emerging artists to established
            brands, our development program will help you turn vision into a fully
            realized merch and creative experience.
          </p>
        </div>
      </section>
      <FeatureBento sections={ARTIST_BENTO_SECTIONS} />
      <section className="px-6 pb-24">
        <div className="max-w-[1400px] mx-auto rounded-2xl border border-white/10 p-10 md:p-14 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <h2 className="font-display text-[#f4efe6] uppercase text-3xl md:text-5xl tracking-tight">Ready to produce?</h2>
            <Link to="/production" className="inline-flex items-center gap-2 mt-4 text-[#cfc8bb] hover:text-[#00b8ff] transition-colors duration-200" data-testid="artist-merch-production-link">
              See all production techniques <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <QuoteButton testid="artist-merch-quote-btn" />
        </div>
      </section>
    </PageShell>
  );
}
